import Modal from "components/elements/Dialog/Modal";
import UploadIssueFileDetails from "./UploadIssueFileDetails";
import UploadIssuesDialogTitle from "./UploadIssuesDialogTitle";
import UploadIssuesFileList from "./UploadIssuesFileList";
import UploadIssueTypeSelection from "./UploadIssueTypeSelection";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";

const UploadPreprocessorDialog = () => {
  const {
    uploadIssues,
    missingFilesDetected,
    clearUploadIssues,
    selectedUploadIssue,
  } = useUploadPreprocessor();

  return (
    <Modal
      className="p-6"
      isOpen={!!uploadIssues.length}
      onClose={clearUploadIssues}
    >
      {(!selectedUploadIssue || missingFilesDetected) && (
        <>
          <div className="space-y-8">
            <UploadIssuesDialogTitle />
            {!missingFilesDetected && <UploadIssueTypeSelection />}
          </div>
          <div className="py-6">
            <UploadIssuesFileList />
          </div>
        </>
      )}

      {selectedUploadIssue && <UploadIssueFileDetails />}
    </Modal>
  );
};

export default UploadPreprocessorDialog;
